import { gql } from '@edreamsodigeo/frontend-api-client';

export const GET_USER_ACCOUNT_INFO = gql`
  query GetUserAccount($userAccountRequest: UserAccountRequest) {
    userAccount(userAccountRequest: $userAccountRequest) {
      email
      isLoggedIn
      userMembership {
        isActive
        subscriptionDetails {
          currentPlanDetails {
            tier
          }
          availablePerks {
            ... on LimitedAvailableMembershipPerk {
              type
            }
            ... on UnlimitedAvailableMembershipPerk {
              type
            }
          }
        }
      }
      userTravellers {
        id
        email
        buyer
        isPrimeOwner
        prefixPhoneNumber
        phoneNumber
        isDefault
        address {
          address
          city
          country
          postalCode
        }
        personalInfo {
          name
          firstLastName
          secondLastName
          ageType
          birthDate
          title
          travellerGender
          nationalityCountryCode
        }
      }
    }
  }
`;

export default GET_USER_ACCOUNT_INFO;
